import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType } from './getExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType';

export type GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwo = {
  content?: string;
  /** 트윗 유형 */
  tweetType?: GetExploreContent200PageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfoAllOfTwoTweetType;
};
